import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../../shared/NavBar';
import PageMetadata from '../../shared/PageMetadata';
import { PAGE_METADATA } from '../../pageMetadata';
import laptopMockup from '../../assets/laptop-mockup.png';
import { managementPath, managementTitle, managementLead, managementWork, managementQuestions, managementPlans, managementTrial, managementLinks } from './sportsClubManagementContent';
import './SportsClubAppPage.css';

export default function SportsClubManagementPage() {
  useEffect(() => {
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = `https://www.shuttleops.com${managementPath}`;
    document.head.appendChild(canonical);
    return () => canonical.remove();
  }, []);

  return <>
    <PageMetadata metadata={PAGE_METADATA[managementPath]} />
    <header className="sports-app-hero">
      <NavBar />
      <div className="sports-app-intro">
        <div>
          <h1>{managementTitle}</h1>
          <p>{managementLead}</p>
          <Link className="sports-app-action" to="/test-club">Try a free test club <span aria-hidden="true">→</span></Link>
          <small>Seven days. 10 fake players. No card or setup call.</small>
        </div>
        <img src={laptopMockup} alt="ShuttleOps Digital Peg Board showing a badminton session across four courts" />
      </div>
    </header>
    <main className="sports-app-main">
      <section className="sports-app-workflow" aria-labelledby="management-work-title">
        <div><h2 id="management-work-title">One record for each club role</h2><p>Club software should help your volunteers before, during and after play. Test the work each person does on a normal club night.</p></div>
        <ol>{managementWork.map(([role, title, copy]) => <li key={role}><span>{role}</span><div><h3>{title}</h3><p>{copy}</p></div></li>)}</ol>
      </section>
      <section className="sports-app-next" aria-labelledby="management-questions-title">
        <div><h2 id="management-questions-title">Three checks before your club moves</h2>{managementQuestions.map(([title, copy]) => <div key={title} className="management-question"><h3>{title}</h3><p>{copy}</p></div>)}</div>
        <div><h2>Try the full handover</h2><p>{managementTrial}</p><h3>Plans and capacity</h3><p>{managementPlans}</p></div>
      </section>
      <section className="sports-app-fit" aria-labelledby="management-next-title">
        <h2 id="management-next-title">See how your club night would run</h2>
        <p>Start with one sample session. Check the booking list, court rotation, attendance and payment record together.</p>
        <nav aria-label="Related club guides">{managementLinks.map(([href, label]) => <Link key={href} to={href}>{label} <span aria-hidden="true">→</span></Link>)}</nav>
      </section>
    </main>
  </>;
}
